import axios from "axios";
import { useQuery } from "react-query";

export const useGetChunkInsightChunks = ({ chunkIds }) => {
  return useQuery(
    ["chunkInsightChunks", chunkIds?.join(",")],
    () =>
      axios
        .get("/api/playground/chunkInsights/chunks", {
          params: { ids: chunkIds.join(",") },
        })
        .then((res) => res.data.chunks || []),
    { enabled: !!chunkIds?.length }
  );
};
